export default [
  {
    type: 'Container',
    minHeight: '150px',
    backgroundImage: {
      url: '{{imageUrl}}',
      verticalAlignment: 'Center',
      horizontalAlignment: 'Center',
    },
    items: [{ type: 'TextBlock', text: '' }],
    verticalContentAlignment: 'Center',
    horizontalAlignment: 'Center',
    spacing: 'Small',
    bleed: true,
  },
];
